export enum ArticlesActionType {
  success = 'articles/ACTION_SUCCESS',
  failure = 'articles/ACTION_FAILURE',
  fetching = 'articles/ACTION_REQUEST',
}
